/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Device } from '../../models/device';
import { DeviceFcmUpdateRequest } from '../../models/device-fcm-update-request';

export interface UpdatePushToken$Params {
      body: DeviceFcmUpdateRequest
}

export function updatePushToken(http: HttpClient, rootUrl: string, params: UpdatePushToken$Params, context?: HttpContext): Observable<StrictHttpResponse<Device>> {
  const rb = new RequestBuilder(rootUrl, updatePushToken.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Device>;
    })
  );
}

updatePushToken.PATH = '/api/v1/devices/update_pushtoken';
